import { render, staticRenderFns } from "./ProductSheet.vue?vue&type=template&id=175d90b2&scoped=true&lang=pug&"
import script from "./ProductSheet.vue?vue&type=script&lang=js&"
export * from "./ProductSheet.vue?vue&type=script&lang=js&"
import style0 from "./ProductSheet.vue?vue&type=style&index=0&id=175d90b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "175d90b2",
  null
  
)

export default component.exports